import axiosInstance from "../../APIs/axiosInstance";

export const fetchPosts = async (page = 1, category = "all", algorithm = "v1") => {
  try {
    let url = `/posts/feed/?page=${page}`;
    if (category && category !== "all") {
      url += `&category=${encodeURIComponent(category)}`;
    }
    url += `&algorithm=${algorithm}`;
    const response = await axiosInstance.get(url);
    return {
      posts: response.data?.results || [],
      next: response.data?.next || null,
      count: response.data?.count || 0,
    };
  } catch (error) {
    console.error("Feed fetch error:", error);
    return { posts: [], next: null, count: 0 };
  }
};
